import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';

import { FuseSharedModule } from '@fuse/shared.module';

import { DialogComponent } from "./dialog.component";
import { ErrorDialogComponent } from './error-dialog.component';


@NgModule({
    declarations: [
        DialogComponent,
        ErrorDialogComponent,
    ],
    imports     : [
        RouterModule,

        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatDialogModule,

        FuseSharedModule
    ],
    exports     : [
        DialogComponent,
        ErrorDialogComponent
    ],
    entryComponents: [
        DialogComponent,
        ErrorDialogComponent
    ],
})
export class DialogModule
{
}
